import React from 'react';
import { Container, Typography, Button } from '@mui/material';

const Setup2FA = () => {
  return (
    <Container maxWidth="md">
      <Typography variant="h2">SETUP 2FA</Typography>

      <Typography variant="h6" marginTop={2}>
        Two-factor Authentication
      </Typography>
      <Typography marginY={2} color={'grey'}>
        The Two-factor Authenticator app enhances the security of your account.
        When this is set up you will be required to provide a verification code
        every time you login to the BlueSana platform.
      </Typography>

      <Button
        style={styles.button}
        type="submit"
        variant="contained"
        color="primary"
        size="medium"
      >
        Setup two-factor authentication
      </Button>
    </Container>
  );
};

export default Setup2FA;

const styles = {
  button: {
    marginTop: '20px',
  },
};
